import { COUNTRIES_DATA } from '@/lib/constants'
import { formatMoneyMinorForAdvertiser } from '@/lib/formatters/money.formatter'
import type { CurrencyType, MoneyServerType } from '@/lib/types'

export const formatMoney = (amount: number, currency: CurrencyType) => {
  return formatMoneyMinorForAdvertiser(
    { amount, currency: currency.code },
    {
      currencySymbol: currency.symbol,
      isSymbolBefore: Boolean(currency.isBefore),
      allowZero: true,
    },
  )
}

export const formatMoneyInLocale = (money: MoneyServerType, locale: string) => {
  const countryLocale = COUNTRIES_DATA.find((country) => country.iso === locale)?.language
  return formatMoneyMinorForAdvertiser(money, {
    allowZero: true,
    currencyLocale: countryLocale,
  })
}
